import { NotificationsComingSoonView, SessionSettingsView } from '@today/ui-domain'
import { useTranslation } from 'react-i18next'
import { useLogOutEverywhere } from '@/hooks/useLogOutEverywhere'
import { SETTINGS_NAMESPACE } from '@/i18n'

/** The Settings "Sessions" section: "Log out everywhere" (TO-197 REQ-009 / REQ-010). */
export function SessionSettings() {
	const { t } = useTranslation(SETTINGS_NAMESPACE)
	const sessions = useLogOutEverywhere()
	return (
		<SessionSettingsView
			isConfirming={sessions.isConfirming}
			onRequest={sessions.request}
			onConfirm={sessions.confirm}
			onCancel={sessions.cancel}
			isBusy={sessions.isBusy}
			error={sessions.hasFailed ? (sessions.error ?? t('sessions.failed')) : null}
			labels={{
				title: t('sessions.title'),
				description: t('sessions.description'),
				logOutEverywhere: t('sessions.logOutEverywhere'),
				confirmTitle: t('sessions.confirmTitle'),
				confirmBody: t('sessions.confirmBody'),
				confirm: t('sessions.logOutEverywhere'),
				cancel: t('sessions.cancel'),
				close: t('sessions.close'),
			}}
		/>
	)
}

/** The disabled "Notifications" card until per-event preferences ship (TO-183 / TO-184). */
export function NotificationsComingSoon() {
	const { t } = useTranslation(SETTINGS_NAMESPACE)
	return (
		<NotificationsComingSoonView
			labels={{
				title: t('notifications.title'),
				description: t('notifications.description'),
				badge: t('notifications.badge'),
			}}
		/>
	)
}
